import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import axios from "axios";

// Import supabase configuration
import supabase from "../../config/supabase";

// import { Grid,Paper, TextField, Button } from '@material-ui/core'
import { Grid, InputBase, Button } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import { makeStyles } from "@material-ui/core/styles";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Box from "@mui/material/Box";
import { Buffer } from "buffer";
import moment from "moment";

import { loginUser, signupUser, getClientNotification } from "../../redux/actions/actions";

import mixpanel from 'mixpanel-browser';
import { nanoid } from "nanoid";

const useStyles = makeStyles(theme => ({
  input: {
    color: "#FFFFFF",
    // "&::placeholder": {
    //   textAlign: "center",
    //   color: "#FFFFFF",
    // },
    // "&::value": {
    //   textAlign: "center",
    //   color: "#FFFFFF",
    // },
    marginBottom: "4px",
  },
}));

const Login = (props) => {

  const [values, setValues] = React.useState({
    password: '',
    email: '',
    showPassword: false,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [clientData, setClientData] = useState("");

  const { currentUser } = useSelector((state) => state.user);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const btnstyle = { margin: `${!errorMessage ? "20px 0 0 0" : ''}`, backgroundColor: "#0F69F6", fontSize: "16px", width: "48%", borderRadius: "4px", textTransform : 'none',};
  const loginbtnstyle = { margin: `${!errorMessage ? "20px 0 0 0" : ''}`, backgroundColor: "#0F69F6", fontSize: "16px", height: '41px', borderRadius: "4px", textTransform : 'none',};
  const Secondbtnstyle = { margin: `${!errorMessage ? "20px 0 0 0" : ''}`, backgroundColor: "#FF4974", fontSize: "16px", width: "48%", borderRadius: "4px", textTransform : 'none',};
  
  const imgStyle = { margin: "10px auto", width: "8em", height: "1.5em" };
  
  
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 1,
    borderRadius: '4.27px',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 300 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? values.password.length <= 3 && values.password.length > 0 ?'#FF1744' : values.password.length >= 3 && values.password.length < 6 ? '#FFCA28' : values.password.length >= 6 && values.password.length < 8 ? '#64DD17' : values.password.length >= 6 ? '#00C853' : '#E0E0E0' : '#308fe8',
    },
  }));

  
  const createUrl = () => {
    var Id = nanoid();
    var board_id = Buffer.from(props.boardId, "utf-8").toString("base64");

    var newId = board_id.concat("/", Id);
    var str = `${window.location.origin}/client?id=`;
    var newUrl = str.concat(newId);

    return newUrl;
  };

  async function sendEmailNotification(message) {
    //Setting email template params
    var templateParams = {
      message: message,
      email: "supply@gaper.io",
      to: values.email,
    };

    //Sending email
    axios
      .post(
        // "http://localhost:5000/sendEmail",
        "https://gaper-email-service.herokuapp.com/sendEmail",
        templateParams,
        {
          headers: { key: "1eb2cy567keyoipaex-assqwe12" },
        }
      )
      .then(function (response) {})
      .catch(function (error) {});
  }

  const insertEmail = async (userEmail, expire, c_url, clientData) => {
    
    if (clientData && clientData.url_with_token.length) {

        var meetingDetails = JSON.parse(sessionStorage.getItem("publicInfo")) || '';
        if(meetingDetails){
          var arrayWithNoDuplicates = meetingDetails.reduce((unique, o) => {
            if(!unique.some(obj => obj.profileId === o.profileId)) {
              unique.push(o);
            }
            return unique;
          },[]);
          var all_profiles = clientData.profiles;

          let profilesWithUpdatedMeetingTime = []
          all_profiles.forEach( (p) => {
            arrayWithNoDuplicates.filter( (prof) => {
              if(p.id === prof.profileId){
                p.meetingTime = prof.startMeetingTime;
                p.endMeetingTime = prof.endMeetingTime;
                p.meetingUrl = prof.meetingUrl;
                p.cencel_url = prof.cencel_url;
                p.reschedule_url = prof.reschedule_url;
                p.event_uuid = prof.event_uuid;
              }
              profilesWithUpdatedMeetingTime.push(p)
            })
          })

          sessionStorage.removeItem("publicInfo");

          const { data, error } = await supabase
          .from("board_clients_invitation")
          .update({profiles: profilesWithUpdatedMeetingTime})
          .match({ email: values.email, board: props.boardId });

          if(data && data.length){
            let date  = new Date(profilesWithUpdatedMeetingTime[0].meetingTime);
            var start = moment(date).format('MMMM Do, h:mm A') ;

            // End meeting time
            let endDate  = profilesWithUpdatedMeetingTime[0].endMeetingTime && new Date(profilesWithUpdatedMeetingTime[0].endMeetingTime);
            var end = endDate ? moment(endDate).format('h:mm A') : "";

            var name = props.profile?.full_name ? props.profile?.full_name.split(" ")[0] : "Akira";
            var message = "You have scheduled a meeting with " + name  + "'s recruitment manager; " + start + " - " + end;
            await insertNotifications(clientData.id,message);

            
            sessionStorage.removeItem("publicInfo");
            let dash_id = Buffer.from(clientData.dashboard_id, "utf-8").toString("base64");
            let link = "dashboard=" + dash_id;
            localStorage.setItem("dashboard", link);
            window.location.href = data[0].url_with_token;
            props.showLoader(false);
          }
        }
        else {
          let dash_id = Buffer.from(clientData.dashboard_id, "utf-8").toString("base64");
          let link = "dashboard=" + dash_id;
          localStorage.setItem("dashboard", link);
          window.location.href = clientData.url_with_token;
          props.showLoader(false);
        }
    } 
    else {
      const response = await supabase
      .from("board_profiles")
      .select("*")
      .match({ board: props.boardId });

      if(response && response.data.length){
        var meetingDetails = JSON.parse(sessionStorage.getItem("publicInfo")) || '';

        var finalArray = [];
        var updatedArray= [];

        // If any candidate is scheduld publically
        if(meetingDetails){ 
          var arrayWithNoDuplicates = meetingDetails.reduce((unique, o) => {
            if(!unique.some(obj => obj.profileId === o.profileId)) {
              unique.push(o);
            }
            return unique;
          },[]);
          var profiles = response.data[0].profiles;
         
          profiles.forEach( (index) => {
            arrayWithNoDuplicates.filter( (secondIndex) => {
              if(index.id === secondIndex.profileId){
                var newState = index;
                newState.meetingTime = secondIndex.startMeetingTime;
                newState.endMeetingTime = secondIndex.endMeetingTime;
                newState.meetingUrl = secondIndex.meetingUrl;
                newState.cencel_url = secondIndex.cencel_url;
                newState.reschedule_url = secondIndex.reschedule_url;
                newState.event_uuid = secondIndex.event_uuid;
                updatedArray.push(newState);
              }
            })
          })
          finalArray = [...updatedArray, ...profiles]
          finalArray = finalArray.reduce((unique, o) => {
            if(!unique.some(obj => obj.id === o.id)) {
              unique.push(o);
            }
            return unique;
          },[]);

        }
        else{
            finalArray = response.data[0].profiles;
        }

        var dashboard_id ="";

        var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ email: values.email});

        if(data && data.length){
          dashboard_id = data[0].dashboard_id;
        }
        
        let masked_url = window.location.origin + "/redirect?" + nanoid().substring(0, 6);

        const res = await supabase
          .from("board_clients_invitation")
          .insert([
            {
              email: userEmail,
              expireDate: expire,
              profiles: finalArray,
              board: props.boardId,
              url_with_token: c_url,
              dashboard_id: dashboard_id ? dashboard_id : nanoid(),
              masked_url: masked_url,
            },
          ]);

          if(res?.data && res.data[0]){
            if(updatedArray.length > 0){
              let date  = new Date(updatedArray[0].meetingTime);
              var start = moment(date).format('MMMM Do, h:mm A') ;
  
              // End meeting time
              let endDate  = updatedArray[0].endMeetingTime && new Date(updatedArray[0].endMeetingTime);
              var end = endDate ? moment(endDate).format('h:mm A') : "";
  
              var name = props.profile?.full_name ? props.profile?.full_name.split(" ")[0] : "Akira";
              var message = "You have scheduled a meeting with " + name  + "'s recruitment manager; " + start + " - " + end;
              await insertNotifications(res.data[0].id,message);
              sessionStorage.removeItem("publicInfo");
              window.location.href = c_url;
              props.showLoader(false);
            } 
            else{
              sessionStorage.removeItem("publicInfo");
              window.location.href = c_url;
              props.showLoader(false);
            }
          } 
      }
    }
  };

  const insertNotifications = async(clientId,message) => {
		// localStorage.removeItem("flag");
		var profile_id = localStorage.getItem("clientBoardProfile");

		var { data, error } = await supabase
		.from("notifications")
		.select("*")
		.match({client: clientId, message: message,profileId: props.profile?.id})

		if(data && data.length <= 0){
				var { data, error } = await supabase
				.from("notifications")
				.insert({client: clientId, message: message,profileId: props.profile?.id})
		
				if(data && data.length){
					localStorage.setItem("showNumber",true);
          dispatch(getClientNotification(clientId));
					props.showLoader(false);
				}
		}
	}

  const sendInvitation = async() => {
    var c_url = createUrl();

    insertEmail(values.email, 10,c_url,"");
    let clientName = values.email.split('@')[0];

    const { data, error } = await supabase
      .from("board_profiles")
      .select("profiles_screenshot")
      .match({ board: props.boardId });
      
    // handleClose();
    if(data && data.length > 0){
      sendEmailNotification(`<div>
      <div style="padding-top:25px">
          <img src="https://yourimageshare.com/ib/ImZrKL2FsS.png" alt="GaperLogo here" height="10%" width="20%" />
      </div>
      <div style="padding:15px 50px">
      <p style=" font-size: 17px;  font-family: 'Poppins', sans-serif; margin: 0px;">Hi ${clientName},</p>
      <p style=" font-size: 16px; font-family: 'Poppins', sans-serif; margin: 0px; padding-top: 3px;">We have customised a team of engineer specific for you.</p>
      <div style="margin-top:20px; font-family: 'Poppins', sans-serif; text-align: center;  position:relative;">
          <div style="padding:40px 0px; border:0.9px solid #C8C8C8; border-radius:10px;">
          <a href='${c_url}'>
          <img src="${data[0].profiles_screenshot}" height="40%" width="90%" alt="ScreenShot Image here" /> </a>
          </div>
          <br />
          <div style="text-align: center;">
          <a href='${c_url}'>
            <button style="background-color: #0C60FF; color:#fff; height:42px; width:170px; border-radius: 4px; border: none; font-size: 18px; font-family: 'Inter', sans-serif; text-align: center;"><a style="color:#fff; text-decoration: none;">View list </a>
            </button>
          </a>
          </div>
          <p style="font-family: 'Poppins', sans-serif; font-size: 16px;">This list is valid for 10 days, Hope to see you soon.</p>
      </div>
      </div>
      </div>`);

    }
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    props.showLoader(true);
    setButtonLoading(true);
    mixpanel.init('de405b9420bcdeddec4d225dc80801ec'); 

    var { data, error } = await supabase
    .from("board_clients_invitation")
    .select("*")
    .match({ board: props.boardId, email: values.email});

    if(!props.isLogin){
      if(values.password.length >= 6){
      dispatch(signupUser(values.email, values.password))
      .then(() => {
        props.handleCloseModal();
        mixpanel.track('Signed up from public link',{
          'email':  values.email,
        });
        // mixpanel.identify(data[0].id);
        mixpanel.people.set({
          $email: values.email,
          $name: values.email,
        });
        localStorage.setItem("loggedIn", true);
        localStorage.removeItem("needLogin");

        props.justView();
        props.showLogin();
        setValues({
          password: '',
          email: '',
          showPassword: false,
        });

        sendInvitation();
      })
      .catch(() => {
        props.showLoader(false);
        setButtonLoading(false)
        setErrorMessage("User already exist");
        console.log("Error");
      });
    } else {
      props.showLoader(false);
      setButtonLoading(false)
      setErrorMessage("Enter 6 digit password");
    }
    } 
    else {
      // For login
        if(data && data.length){
          dispatch(loginUser(values.email, values.password))
          .then( () => {
            props.handleCloseModal();
            mixpanel.track('Logged in from public link',{
              'email':  values.email,
            });
            mixpanel.identify(data[0].id);
            mixpanel.people.set({
              $email: values.email,
              $name: values.email,
            });
            localStorage.setItem("loggedIn", true);
            localStorage.removeItem("needLogin");
            insertEmail('','','', data[0]);
            props.justView();
            props.showLogin();
            
            setValues({
              password: '',
              email: '',
              showPassword: false,
            });
            
          })
          .catch(() => {
            props.showLoader(false);
            setButtonLoading(false)
            setErrorMessage("Invalid email or password");
            console.log("Error");
          });
        }
        // Share another board to same email
        else{
            dispatch(loginUser(values.email, values.password))
            .then(() => {
              props.handleCloseModal();
              mixpanel.track('Logged in for new board from public link',{
                'email':  values.email,
              });
              // mixpanel.identify(data[0].id);
              mixpanel.people.set({
                $email: values.email,
                $name: values.email,
              });
              localStorage.setItem("loggedIn", true);
              localStorage.removeItem("needLogin");
      
              props.justView();
              props.showLogin();
              setValues({
                password: '',
                email: '',
                showPassword: false,
              });
      
              sendInvitation();
            })
            .catch(() => {
              props.showLoader(false);
              setButtonLoading(false)
              setErrorMessage("Invalid email or password");
              console.log("Error");
            });
          }
        }
    };

  // const toLogin = () => {
  //   setIsLogin(true);
  // }

  const handleClickShowPassword = (e) => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleNotNowClick = () => {
    mixpanel.track('Skip',{
      'email':  values.email,
    });
    localStorage.setItem("loggedIn", false);
    setValues({
      password: '',
      email: '',
      showPassword: false,
    });
    props.handleCloseModal();
  }

  return (
        <div className="flex justify-center">
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            style={{ marginTop: "12px", backgroundColor: '#232428', padding: "40px 20px 20px 20px",  borderRadius: '4.27px'}}
          >
              <Grid align="center">
                <h1 className="text-[#969696] text-xs 1xl:text-base">{props.isLogin ? "WELCOME BACK" : "Welcome"}</h1>
                <h1 className="text-[#FFFFFF] font-semibold text-lg xl-2:text-1xl">{props.isLogin ? "Log into your account" : "Create an account"}</h1>
              </Grid>
                { !props.isLogin ?
                  <form className="w-11/12 1xl:mt-2 text-center" onSubmit={handleSubmit}>
                  <div className="mb-8">
                    <input 
                    type="email" 
                    name="email" 
                    id="email" 
                    placeholder="Enter your email"
                    onClick={() => setErrorMessage("")}
                    onChange={handleChange('email')}
                    className={`border-b bg-[#232428] text-[#FFFFFF] w-full focus:outline-none text-[16px] mt-10  pb-2`}
                    />
                    <input 
                    type="password" 
                    name="password" 
                    id="password" 
                    placeholder="Create a strong password"
                    onClick={() => setErrorMessage("")}
                    onChange={handleChange('password')}
                    className={` bg-[#232428] text-[#FFFFFF] w-full focus:outline-none text-[16px] mt-5  pb-2`}
                    />
                    <Box sx={{ flexGrow: 1, marginTop: '-23px' }}>
                      {/* <FacebookCircularProgress /> */}
                      <br />
                      <BorderLinearProgress variant="determinate" value={values.password.length <= 3 && values.password.length > 0 ? 25 : values.password.length >= 3 && values.password.length < 6 ? 50 : values.password.length >= 6 && values.password.length < 8 ? 75 : values.password.length >= 8 ? 100 : 0} />
                    </Box>
                    <div className="flex justify-between mt-1">
                      {values.password.length > 0 && 
                        <>
                          <div className="text-[10px] text-[#FFFFFF]">
                            {values.password.length <= 3 && values.password.length > 0 ? (
                            <div className="flex">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" className="mt-0.5"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" fill="rgba(231,76,60,1)"/></svg><span className="ml-1 text-left">Your password should be at least 6-8 characters long</span>
                            </div>)
                            : values.password.length >= 3 && values.password.length < 6 ? 'Use numbers to make it stronger' : values.password.length >= 6 && values.password.length < 8 ? 'Use both uppercase and lowercase letters' : values.password.length >= 8 ? 'Good job! Your password looks strong.' : ''}
                          </div>  
                          <div className={`${values.password.length <= 3 && values.password.length > 0 ?'text-[#FF1744]' : values.password.length >= 3 && values.password.length < 6 ? 'text-[#FFCA28]' : values.password.length >= 6 && values.password.length < 8 ? 'text-[#64DD17]' : values.password.length >= 8 ? 'text-[#00C853]' : 'text-[#E0E0E0]'} text-xs`}>
                            {values.password.length <= 3 && values.password.length > 0 ?'Weak' : values.password.length >= 3 && values.password.length < 6 ? 'Fair' : values.password.length >= 6 && values.password.length < 8 ? 'Good' : values.password.length >= 8 ? 'Strong' : ''}
                          </div>  
                        </>
                      }
                    </div>
                  </div>

                  {errorMessage && (
                    <div className="my-2 flex text-right text-red-1 col-span-12">{errorMessage}</div>
                  )}
                  <div className="flex justify-between mb-5">
                  <Button
                      type="button"
                      variant="contained"
                      size="medium"
                      style={Secondbtnstyle}
                      onClick={handleNotNowClick}
                      fullWidth
                      >
                      Skip
                    </Button>
                    
                    <LoadingButton
                      loading={buttonLoading}
                      type="submit"
                      variant="contained"
                      size="medium"
                      style={btnstyle}
                      fullWidth
                      >
                      Set now
                    </LoadingButton>
                  </div>
                  <div className="flex justify-between text-sm font-normal 1xl:text-base text-[#FFFFFF] mt-5 mb-3">
                      <div className="">Already have an account? <span className="text-blue-1 font-normal cursor-pointer" onClick={() => {
                        setValues({
                          password: '',
                          email: '',
                          showPassword: false,
                        });
                        props.isSignUp(true);
                      }}>Login</span></div>
                  </div>
                  </form>
                  :
                  <form className="w-full mt-5 p-4" onSubmit={handleSubmit}>
                    <div>
                      <InputBase
                        required
                        id="outlined-adornment-password1"
                        type='text'
                        value={values.email}
                        // defaultValue={props.clientEmail}
                        placeholder="Enter your email"
                        onChange={handleChange('email')}
                        style={{color: "#FFFFFF",
                        // border: "0.2px solid #969696",
                        position: 'relative',
                        // borderRadius: 1.65,
                        height: '35px',
                        marginTop: '5px',
                        marginBottom: '20px',
                        fontSize: 16,
                        // padding: '10px 18px',
                      }}
                      // fullWidth
                      onClick={() => setErrorMessage("")}
                      // required
                      className={`border-b bg-[#232428] text-[#FFFFFF] w-full focus:outline-none text-[16px] mt-10  pb-2`}
                      />
                      <InputBase
                        variant="standard"
                        id="outlined-adornment-password"
                        type={values.showPassword ? 'text' : 'password'}
                        value={values.password}
                        placeholder="Enter your Password"
                        onChange={handleChange('password')}
                        style={{color: "#FFFFFF",
                        // border: "0.2px solid #969696",
                        // position: 'relative',
                        // borderRadius: 1.65,
                        height: '35px',
                        marginTop: '5px',
                        marginBottom: '5px',
                        fontSize: 16 ,
                        padding: '10px 0px',
                      }}
                      fullWidth
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              style={{color: '#474747', }}
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {values.showPassword ? <VisibilityOff style={{width: '20px'}} /> : <Visibility style={{width: '20px' }} />}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Password"
                        onClick={() => setErrorMessage("")}
                        required
                        className={`border-b bg-[#232428] text-[#FFFFFF] w-full focus:outline-none text-[16px] mt-10  pb-2`}
                      />
                    </div>
                  {errorMessage && (
                    <div className="my-2 flex text-right text-sm text-red-1 col-span-12">{errorMessage}</div>
                    )}
                  <div className="flex justify-between mb-5">
                    <Button
                      type="button"
                      variant="contained"
                      size="medium"
                      style={Secondbtnstyle}
                      onClick={handleNotNowClick}
                      fullWidth
                      >
                      Skip
                    </Button>
                    <LoadingButton
                      loading={buttonLoading}
                      type="submit"
                      variant="contained"
                      size="medium"
                      style={btnstyle}
                      fullWidth
                      >
                      Log In
                    </LoadingButton>
                  </div>
                  <div className="flex justify-between text-sm font-normal 1xl:text-base text-[#FFFFFF] mt-5 mb-3">
                      <div className="">Not registered yet? <span className="text-blue-1 font-normal cursor-pointer" onClick={() => {
                        setValues({
                          password: '',
                          email: '',
                          showPassword: false,
                        });
                        props.isSignUp(false);
                      }}>Register now</span></div>
                  </div>
                  </form>
                }
          </Grid>
        </div>
  );
};

export default Login;
